import { gql } from '@apollo/client'

export const GET_EVENT_BY_ID_FOR_EDITOR = gql`
  query getEventByIdForEditor($input: GetEventByIdInput!) {
    getEventById(input: $input) {
      eventId
      organizerId
      isPublished
      isPremium
      isComplete
      dateCreated
      notifyOrganiser
      paymentProcessor
      availableTickets {
        tickets {
          ticketTitle
          totalQuantity
          remaining
          discountCodes {
            title
            type
            remaining
          }
        }
      }
      event {
        bannerImage
        description
        eventMainColour
        eventBackgroundColour
        eventTextColour
        endDateTime
        registrationCloseDateTime
        shortDescription
        startDateTime
        entryDateTime
        title
        organizationName
        thumbnailImage
        publiclyListed
        currency
        eventLocation
        eventLocationMapUrl
        eventLocationMapLink
        donationUrl
        eventType
        blackbaudId
        timeZone
        timeZoneId
        isInternal
        internalLocation
        showAttendeeBox
      }
      discounts {
        title
        type
        percentage
        amount
        quantity
        tickets
        code
      }
      registrationFields {
        name
        type
        unique
        dateOnly
        visibleOnAttendeeList
        required
        options {
          value
          label
        }
      }
      fundraising {
        enabled
        id
        title
        description
        goal
        feeAbsorption
        programs {
          title
          description
          goal
          media {
            title
            body
            platform
            url
          }
          active
          enabled
        }
        media {
          title
          body
          platform
          url
        }
      }
      tickets {
        price
        ticketType
        title
        quantity
        allowMultiplePurchase
      }
      speakers {
        userId
        email
        name
        organization
        position
        profileImage
        ticketType
        bio
      }
      stages {
        class
        description
        holdingVideoUrl
        title
      }
      sponsors {
        description
        facebookUrl
        linkedinUrl
        logoUrl
        title
        twitterUrl
        websiteUrl
        ondemandContent {
          url
          title
          description
          id
        }
      }
      sessions {
        description
        endDateTime
        speakers {
          userId
          email
          name
          organization
          position
          profileImage
          ticketType
          bio
        }
        stage {
          class
          description
          holdingVideoUrl
          title
        }
        startDateTime
        title
        isBreak
      }
      breakoutRooms {
        thumbnailImage
        description
        maxAttendees
        title
      }
      communications {
        socials {
          platform
          url
        }
        announcements {
          title
          body
        }
      }
      ondemandContent {
        id
        url
        title
        description
      }
      attendees {
        email
        name
        profileImage
        ticketTitle
        invitationSentDatetime
        registered
        checkInStatus
        checkInDatetime
        badgePrintedAt
        ticketCode
        isAdditionalGuest
        userId
        orderId
        registrationVisible
        requireRegistrationFields
      }
      notifications {
        title
        timestamp
        notificationType
        status
      }
      emailTemplates {
        templateId
        content
        title
        trigger
        enabled
        data
        sentDateTime
        schedule {
          scheduleId
          runAt
          status
        }
      }
      publicationSchedule {
        runAt
        status
      }
    }
  }
`
